import React from 'react';
import Image from 'next/image';
import StarRating from '../../../../molecules/StarRating';

interface TutorPartProps {
  name: string;
  description: string;
  photoUrl: string;
}

const TutorPart: React.FC<TutorPartProps> = ({
  name,
  description,
  photoUrl,
}) => {
  return (
    <div className="bg-white rounded-lg p-6 text-center shadow-sm">
      <div className="mb-4 flex justify-center">
        <div className="relative">
          <Image
            src={photoUrl}
            height={96}
            width={96}
            alt={name}
            className="rounded-full object-cover ring-4 ring-[#fbe4dc]"
          />
        </div>
      </div>
      <h4 className="font-serif text-xl font-medium text-[#1c1c1c] mb-2">
        {name}
      </h4>
      <div className="flex justify-center mb-3">
        <StarRating rating={5} />
      </div>
      <p className="text-[15px] text-[#1c1c1c]/65 leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default TutorPart;
